import Reveal from "../components/Reveal";

const LINES = ["Plusieurs projets,", "un même élan,", "chacun sa trajectoire."];
const SAMPLE = "Entre jazz, improvisation et musiques parallèles — des musiques qui respirent et relient.";

const CANDIDATES = [
  { id: "satoshi", name: "Satoshi", kind: "sans-serif néo-grotesque — l'esprit TWK Lausanne, libre", family: "'Satoshi', sans-serif", weight: 300 },
  { id: "general-sans", name: "General Sans", kind: "sans-serif suisse, neutre et net", family: "'General Sans', sans-serif", weight: 300 },
  { id: "clash-display", name: "Clash Display", kind: "sans-serif de caractère, impact éditorial", family: "'Clash Display', sans-serif", weight: 400 },
  { id: "zodiak", name: "Zodiak", kind: "serif éditorial, robuste et chaleureux", family: "'Zodiak', serif", weight: 300 },
  { id: "boska", name: "Boska", kind: "serif à fort contraste, très élégant", family: "'Boska', serif", weight: 300 },
  { id: "boska-air-1", num: "05b", name: "Boska", kind: "interlettre élargi (+0,01 em)", family: "'Boska', serif", weight: 300, spacing: "0.01em" },
  { id: "boska-air-2", num: "05c", name: "Boska", kind: "interlettre élargi (+0,02 em)", family: "'Boska', serif", weight: 300, spacing: "0.02em" },
  { id: "boska-air-3", num: "05d", name: "Boska", kind: "interlettre élargi (+0,03 em)", family: "'Boska', serif", weight: 300, spacing: "0.03em" },
  { id: "sentient", name: "Sentient", kind: "serif vivant, italiques pleines de personnalité", family: "'Sentient', serif", weight: 300 },
  { id: "fraunces", name: "Fraunces", kind: "serif doux — la proposition précédente, pour comparer", family: "'Fraunces', serif", weight: 300 },
];

export default function TypoLab() {
  return (
    <main className="pt-32 sm:pt-36 pb-24 min-h-screen" data-testid="typo-lab">
      <section className="jm-container mb-16">
        <Reveal>
          <p className="jm-overline mb-5">Laboratoire typographique</p>
          <h1 className="font-serif font-light text-3xl sm:text-4xl text-jm-bone leading-tight max-w-3xl">
            Sept propositions pour le titre de l'accueil
          </h1>
          <p className="mt-6 max-w-2xl text-base text-jm-smoke leading-relaxed">
            La même phrase d'accroche, dans sept typographies libres de droits et pleines de caractère.
            Notez le numéro de votre préférée — je l'appliquerai au site.
          </p>
        </Reveal>
      </section>

      <section className="jm-container space-y-20">
        {CANDIDATES.map((c, i) => (
          <Reveal key={c.id} delay={0.05}>
            <div className="border-t border-jm-brass/10 pt-10" data-testid={`typo-candidate-${c.id}`}>
              <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-jm-mute mb-6">
                {c.num || String(i + 1).padStart(2, "0")} — {c.name} · {c.kind}
              </p>
              <p
                className="text-jm-bone text-[11vw] sm:text-5xl lg:text-6xl leading-[1.08] tracking-tight"
                style={{ fontFamily: c.family, fontWeight: c.weight, ...(c.spacing ? { letterSpacing: c.spacing } : {}) }}
              >
                {LINES[0]}
                <br />
                {LINES[1]}
                <br />
                <em className="italic text-jm-brass">{LINES[2]}</em>
              </p>
              <p className="mt-6 text-jm-smoke text-base max-w-xl leading-relaxed" style={{ fontFamily: c.family }}>
                {SAMPLE}
              </p>
            </div>
          </Reveal>
        ))}
      </section>
    </main>
  );
}
